import * as React from "react";
import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { Button } from "azure-devops-ui/Button";
import { Checkbox } from "azure-devops-ui/Checkbox";
import { Observer } from "azure-devops-ui/Observer";
import { Location } from "azure-devops-ui/Utilities/Position";

export default class CalloutWithAnchorPoint extends React.Component {
    public render() {
        const fixedLayout = new ObservableValue<boolean>(false);
        return (
            <Observer fixedLayout={fixedLayout}>
                {(layoutProps: { fixedLayout: boolean }) => (
                    <div className="flex-column flex-grow" style={{ margin: "8px" }}>
                        <div className="flex-row" style={{ justifyContent: "space-between" }}>
                            <Button
                                text="Tooltip Button"
                                tooltipProps={{
                                    anchorOffset: { horizontal: -8, vertical: -8 },
                                    fixedLayout: layoutProps.fixedLayout,
                                    showOnFocus: true,
                                    text: "This tooltip is designed to overflow to the top left",
                                    tooltipOrigin: {
                                        horizontal: Location.end,
                                        vertical: Location.end
                                    }
                                }}
                            />
                            <Button
                                tooltipProps={{
                                    anchorOffset: { horizontal: 0, vertical: -8 },
                                    fixedLayout: layoutProps.fixedLayout,
                                    showOnFocus: true,
                                    text: "This tooltip is designed to overflow to the top center",
                                    tooltipOrigin: {
                                        horizontal: Location.center,
                                        vertical: Location.end
                                    }
                                }}
                            >
                                Tooltip Button
                            </Button>
                            <Button
                                text="Tooltip Button"
                                tooltipProps={{
                                    anchorOffset: { horizontal: 8, vertical: -8 },
                                    fixedLayout: layoutProps.fixedLayout,
                                    showOnFocus: true,
                                    text: "This tooltip is designed to overflow to the top right",
                                    tooltipOrigin: {
                                        horizontal: Location.start,
                                        vertical: Location.end
                                    }
                                }}
                            />
                        </div>
                        <div className="flex-row flex-grow">
                            <div
                                className="flex-row flex-grow flex-self-center"
                                style={{ justifyContent: "space-between" }}
                            >
                                <Button
                                    text="Tooltip Button"
                                    tooltipProps={{
                                        anchorOffset: { horizontal: -8, vertical: -8 },
                                        fixedLayout: layoutProps.fixedLayout,
                                        showOnFocus: true,
                                        text:
                                            "This tooltip is designed to overflow to the top left",
                                        tooltipOrigin: {
                                            horizontal: Location.end,
                                            vertical: Location.end
                                        }
                                    }}
                                />
                                <Checkbox
                                    checked={fixedLayout}
                                    label="Fix Layout"
                                    onChange={(event, value: boolean) => {
                                        fixedLayout.value = value;
                                    }}
                                />
                                <Button
                                    text="Tooltip Button"
                                    tooltipProps={{
                                        anchorOffset: { horizontal: 8, vertical: 8 },
                                        fixedLayout: layoutProps.fixedLayout,
                                        showOnFocus: true,
                                        text:
                                            "This tooltip is designed to overflow to the top right",
                                        tooltipOrigin: {
                                            horizontal: Location.start,
                                            vertical: Location.start
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="flex-row" style={{ justifyContent: "space-between" }}>
                            <Button
                                text="Tooltip Button"
                                tooltipProps={{
                                    anchorOffset: { horizontal: -8, vertical: 8 },
                                    fixedLayout: layoutProps.fixedLayout,
                                    showOnFocus: true,
                                    text: "This tooltip is designed to overflow to the bottom left",
                                    tooltipOrigin: {
                                        horizontal: Location.end,
                                        vertical: Location.start
                                    }
                                }}
                            />
                            <Button
                                text="Tooltip Button"
                                tooltipProps={{
                                    anchorOffset: { horizontal: 0, vertical: 8 },
                                    fixedLayout: layoutProps.fixedLayout,
                                    showOnFocus: true,
                                    text:
                                        "This tooltip is designed to overflow to the bottom center",
                                    tooltipOrigin: {
                                        horizontal: Location.center,
                                        vertical: Location.start
                                    }
                                }}
                            />
                            <Button
                                text="Tooltip Button"
                                tooltipProps={{
                                    anchorOffset: { horizontal: 8, vertical: 8 },
                                    fixedLayout: layoutProps.fixedLayout,
                                    showOnFocus: true,
                                    text:
                                        "This tooltip is designed to overflow to the bottom right",
                                    tooltipOrigin: {
                                        horizontal: Location.start,
                                        vertical: Location.start
                                    }
                                }}
                            />
                        </div>
                    </div>
                )}
            </Observer>
        );
    }
}
